import { render, staticRenderFns } from "./CatalogProductEdit.vue?vue&type=template&id=d9637a24&scoped=true&"
import script from "./CatalogProductEdit.vue?vue&type=script&lang=js&"
export * from "./CatalogProductEdit.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProductEdit.vue?vue&type=style&index=0&id=d9637a24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9637a24",
  null
  
)

export default component.exports